module.exports = __webpack_public_path__ + "img/star10.ff114f35.png";